import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { CircleFlag } from "react-circle-flags";

import { LANGUAGES } from "../../../constants";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (e: any) => {
    const languageCode = e;
    i18n.changeLanguage(languageCode);
  };

  return (
    <Select value={i18n.language} onChange={handleChangeLanguage}>
      {LANGUAGES.map(({ code, flag }) => (
        <Select.Option key={code} value={code}>
          <CircleFlag countryCode={flag} width={20} height={20} />
        </Select.Option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
